import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { AuthContext } from "../../index.js";
import "./SignupStyle.css";
import { printDebugLog } from "../../Utils/utils.js";
import OtpDialog from "../OtpForm/OtpDialog.jsx";

const Signup = () => {
  const { userSignup, verifyMobEmailOtp } = useContext(AuthContext);
  const [userDetails, setUserDetails] = useState({
    user: "",
    mobile: "",
    email: "",
    password: "",
  });
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [isPasswordHide, setIsPasswordHide] = useState(true);
  const [isConfirmPasswordHide, setIsConfirmPasswordHide] = useState(true);
  const [openOtpDialog, setOpenOtpDialog] = useState(false);

  const handleSubmitOtps = ({ mobileOtp, emailOtp }) => {
    // do your API call here
    printDebugLog("Mobile OTP:", mobileOtp);
    printDebugLog("Email OTP:", emailOtp);
    verifyMobEmailOtp(userDetails, mobileOtp, emailOtp, (isError) => {
      setOpenOtpDialog(!isError);
    })
  };

  const signupDataHandler = (e) => {
    e.preventDefault();
    if (Object.values(userDetails).includes("")) {
      toast.error("Please enter valid input!");
    } else if (confirmPassword !== userDetails.password) {
      toast.error("Password and Comfirm Password Not Matching!!");
    } else {
      userSignup(userDetails, () => {
        //openOtpDialog Otp Dialog
        setOpenOtpDialog(true);
      });
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="signup-page-container">
      <h1 className="signupHeading">Signup Page</h1>
      <div className="signup-form-container">
        <form onSubmit={(e) => signupDataHandler(e)}>
          <div className="signup-field">
            <label htmlFor="firstName">User Name</label>
            <input
              type="text"
              id="user"
              placeholder="test"
              required
              onChange={(e) =>
                setUserDetails((prev) => ({
                  ...prev,
                  user: e.target.value,
                }))
              }
            />
          </div>
          <div className="signup-field">
            <label htmlFor="mobile">Mobile Number</label>
            <input
              type="tel"                 // better than number: supports maxLength + mobile keyboards
              id="mobile"
              placeholder="Enter 10-digit mobile number"  // no +91
              required
              inputMode="numeric"
              pattern="\d*"
              maxLength={10}
              value={userDetails.mobile || ""}
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 10);
                setUserDetails((prev) => ({
                  ...prev,
                  mobile: onlyDigits,
                }));
              }}
            />
          </div>
          <div className="signup-field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="test@gmail.com"
              required
              onChange={(e) =>
                setUserDetails((prev) => ({ ...prev, email: e.target.value }))
              }
            />
          </div>
          <div className="signup-field">
            <label htmlFor="password">Password</label>
            <input
              type={isPasswordHide ? "password" : "text"}
              placeholder={isPasswordHide ? "********" : "Enter Password"}
              id="password"
              required
              onChange={(e) =>
                setUserDetails((prev) => ({
                  ...prev,
                  password: e.target.value,
                }))
              }
            />
            <span onClick={() => setIsPasswordHide(!isPasswordHide)}>
              {isPasswordHide ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
            </span>
          </div>
          <div className="signup-field">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type={isConfirmPasswordHide ? "password" : "text"}
              placeholder={
                isConfirmPasswordHide ? "********" : "Enter Password"
              }
              id="confirmPassword"
              required
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <span
              onClick={() => setIsConfirmPasswordHide(!isConfirmPasswordHide)}
            >
              {isConfirmPasswordHide ? (
                <AiOutlineEyeInvisible />
              ) : (
                <AiOutlineEye />
              )}
            </span>
          </div>
          <button className="signup-btn" type="submit">
            Signup
          </button>
        </form>
        <p className="signup-login-btn" onClick={() => navigate("/login")}>
          Already Have an Account ?
        </p>
      </div>
      <OtpDialog
        open={openOtpDialog}
        mobileNumber={userDetails.mobile}
        emailId={userDetails.email}
        onClose={() => setOpenOtpDialog(false)}
        onSubmit={handleSubmitOtps}
      />
    </div>
  );
};
export { Signup };
